import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Input, Table, Spin, Divider } from 'antd';
import axios from "axios";
function ShowResult() {

    const [DataDB, setDataDB] = useState([]);

    useEffect(() => {
        get_from_data_db();
    }, []);

    async function get_from_data_db() {
        try {
            const res = await axios.post('/api/data_db/get_from_data_db', {});
            console.log('get_data_db--------->', res);
            if (res.data?.success) {
                setDataDB(res.data.data);
            }
        } catch (error) {
            console.error('Failed to fetch reservations:', error);
            // 서버 연결 실패 시 기본 동작 설정
            setDataDB([]);
        }
    }

    async function delete_from_data_db(data_db_id) {
        try {
            const res = await axios.post('/api/data_db/delete_from_data_db', {data_db_id: data_db_id});
            console.log('delete_from_data_db--------->', res);
            if (res.data?.success) {
                get_from_data_db();
            }
        } catch (error) {
            console.error('Failed to delete data_db:', error);
        }
    }

    console.log('DataDB', DataDB);
    const render_data_db = DataDB  && DataDB.map(function(data_db, index){
        const extra_request = data_db.extra_request || 'No request';
        return (
            <tr key={index}>
                <td>{index+1}</td>
                <td>{data_db.name}</td>
                <td>{data_db.date}</td>
                <td>{data_db.time}</td>
                <td>{data_db.party_size}</td>
                <td>{extra_request}</td>
                <td><Button onClick={() => delete_from_data_db(data_db._id)}>Delete</Button></td>
            </tr>
        );
    });      

    return (
        <div style={{textAlign:'center'}}>
            <h3>DataDB</h3> 

            <Row justify='center'>
                <Col span={12}>
                    <table>
                        <thead>
                            <tr>
                                <th>Item</th>
                                <th>Name</th>
                                <th>Date</th>
                                <th>Time</th>
                                <th>Party Size</th>
                                <th>Request</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {render_data_db || <tr><td colSpan="6">No reservations available</td></tr>}
                        </tbody>
                    </table>
                </Col>
            </Row>

        </div>
    )
}

export default ShowResult
